import { css } from "@emotion/react";
import { styled } from "../theme";
export const DropdownMenuItemBase = styled.div `
  padding: 15px;
  color: ${({ theme }) => theme.color.darkBlue100};
  font-size: 15px;
  font-weight: ${({ theme }) => theme.fontWeight.medium};
  position: relative;
  cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
  ${({ disabled, theme }) => disabled
    ? "opacity: 0.5;"
    : `
    &:hover {
      background-color: ${theme.color.lightBlue10};
    }
    `}

  ${({ active, theme }) => active &&
    css `
      background-color: ${theme.color.lightBlue10};
    `}
`;
